// TCGplayer affiliate (Impact) deep links.
//
// The partner link https://partner.tcgplayer.com/c/7719537/1830156/21018 is an
// Impact tracking link: appending `?u=<encoded destination>` sends the visitor
// to any TCGplayer page while still crediting the click, and `subId1` carries
// our own attribution key (card code or sealed product key), matching the way
// eBay Partner Network sub-ids are used elsewhere on the site.

export const TCGPLAYER_PARTNER_URL = "https://partner.tcgplayer.com/c/7719537/1830156/21018";

/** Attribution key: lowercase, hyphen-safe, capped like the EPN sub-id. */
export function tcgplayerSubId(key: string): string {
  return (
    "palstars-" +
    String(key ?? "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "")
      .slice(0, 40)
  );
}

/**
 * Wraps a tcgplayer.com destination in the partner tracking link.
 * Non-TCGplayer URLs are returned untouched so callers can pass any URL safely.
 */
export function tcgplayerAffiliateUrl(destination: string, subId?: string): string {
  if (!/^https?:\/\/([a-z0-9-]+\.)*tcgplayer\.com\//i.test(destination)) return destination;
  const params = new URLSearchParams({ u: destination });
  if (subId) params.set("subId1", tcgplayerSubId(subId));
  return `${TCGPLAYER_PARTNER_URL}?${params.toString()}`;
}
